import { basicEnum } from "./base";

export const SecretNameEnum = basicEnum([
    {
        label: "Xendit Token",
        value: "xenditToken",
    },
    {
        label: "WhatsApp Phone",
        value: "whatsAppPhone",
    },
    {
        label: "WhatsApp Token",
        value: "whatsAppToken",
    },
    {
        label: "Firebase Service Account",
        value: "firebaseServiceAccount",
    },
]);

export namespace SecretNameEnum {
    export type Labels = (typeof SecretNameEnum)["labels"][number];
    export type Values = (typeof SecretNameEnum)["values"][number];
}
